import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";


import * as serviceWorker from './serviceWorker';
import App from './App';


const routing = (  
  <BrowserRouter>
    <App/></BrowserRouter>
  )  
ReactDOM.render(routing, document.getElementById('hiber'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
